import React from 'react';

import './bank-upload-multi-fail.css';
import { Divider } from 'rsuite';

const BankUploadMultiFail = ({ isFromProd, isVisible, message, onClose, errorRecords }) => {
    if (!isVisible) return null;

    // const {
    //     errorRecords = [],
    // } = data || {};

    return (
        <div className="error-summary-overlay">
            <div className="error-summary-container">
                <div className="error-summary-header">
                    <div className="error-summary-info">
                        <span>{message ??'Looks like some bank statements have encountered errors while processing'}</span>
                    </div>
                </div>



                <div className="error-table-50-50-container">
                    <table className="error-table-50-50">
                        <thead>
                            <tr>
                                <th>File Name</th>
                                <th>Error Description</th>
                            </tr>
                        </thead>
                    </table>
                    <div className="error-table-50-50-body-scroll">
                        <table className="error-table-50-50">
                            {/* {isFromProd === true && <tbody>
                                {errorRecords.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.row}</td>
                                        <td>{item.error}</td>
                                    </tr>

                                ))}
                            </tbody>} */}

                            <tbody>
                                {errorRecords.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.fileName}</td>
                                        <td>{item.message}</td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>


                <div className="error-summary-footer pt-2">
                    <button type='button' className='next-button' onClick={onClose} >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BankUploadMultiFail;
